import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { salesCategoryByDay: { getSalesCategoryByDay } } = apiUrls;

export const SALES_CATEGORY_BY_DAY_SUCCESS = 'SALES_CATEGORY_BY_DAY_SUCCESS';
export const SALES_CATEGORY_BY_DAY_LOADING = 'SALES_CATEGORY_BY_DAY_LOADING';

export const getSalesCategoryByDayData = ({ from, to, vendor }) => async (dispatch) => {
    try {
        if (vendor) {
            const requestData = {
                ...getSalesCategoryByDay,
                url: getSalesCategoryByDay.url.replace('{from}', from).replace('{to}', to).replace("{{vendor}}", vendor)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: SALES_CATEGORY_BY_DAY_SUCCESS,
                data,
                vendor
            })
        }

    } catch (e) {

        dispatch({
            type: SALES_CATEGORY_BY_DAY_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            },
            vendor
        })
    }

}

export const handleLoader = (isLoading, vendor) => (dispatch) => {
    if (vendor) {
        dispatch({
            type: SALES_CATEGORY_BY_DAY_LOADING,
            isLoading,
            vendor
        });
    }
}